<template>
  <div class="plan-list-item-row">
    <div
      class="plan-list-item-row__subscription-header plan-list-item-row__subscription-header--premium"
    >
      <div class="plan-list-item-row__subscription-header-title">Premium Subscription</div>
      <div class="plan-list-item-row__subscription-header-subtitle">
        Full Access to INE's entire course library
      </div>
    </div>
    <PlanRowItem
      v-for="plan in plans"
      :key="plan.id"
      :plan="plan"
      class="subscriptions-list__products-plans-individuals-item"
    />
  </div>
</template>

<script>
import PlanRowItem from '@/components/plan-item-card/PlanRowItem.vue'

export default {
  name: 'PlanListItemRow',
  components: {
    PlanRowItem,
  },
  props: {
    plans: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.plan-list-item-row {
  margin-bottom: 60px;
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 20px;
  @include mobile {
    grid-template-columns: repeat(2, 1fr);
    grid-row-gap: 0;
    grid-column-gap: 20px;
  }
  @include desktop {
    grid-template-columns: repeat(3, 1fr);
  }
  &__subscription {
    &-header {
      background: var(--purple-gradient-two-vertical);
      border-radius: 10px 10px 0 0;
      margin-top: 0;
      margin-bottom: 0;
      height: 100px;
      padding: 20px;
      @include mobile {
        grid-column: 1 / 3;
        padding: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
      @include desktop {
        margin: 30px 0;
        border-radius: 10px;
        padding: 40px;
        height: auto;
        grid-column: 1 / 2;
        background: var(--purple-gradient-two);
        flex-flow: column;
        justify-content: flex-start;
      }
      &--premium {
        background: url('../../assets/images/backgrounds/plans_premium_mobile.png'),
          var(--purple-gradient-two-vertical);
        background-repeat: no-repeat;
        background-position: top right;
        @include mobile {
          background: url('../../assets/icons/plans/premium.png'),
            var(--purple-gradient-two-vertical);
          background-position: center;
          background-repeat: no-repeat;
        }
        @include desktop {
          background: url('../../assets/icons/plans/premium.png'), var(--purple-gradient-two);
          background-color: var(--purple-gradient-two);
          background-repeat: no-repeat;
          background-position: bottom left;
        }
      }
      &-title {
        font-weight: 700;
        font-size: 32px;
        line-height: 38px;
        padding-bottom: 30px;
        @media screen and (max-width: 1236px) {
          padding-bottom: 0;
          font-size: 24px;
          line-height: 32px;
        }
      }
      &-subtitle {
        font-weight: 500;
        font-size: 16px;
        line-height: 24px;
        color: var(--purple-pale);
        grid-area: 2/1/2/3;
        justify-self: self-start;
        @include mobile {
          font-size: rem(18px);
          line-height: 24px;
          justify-self: self-end;
        }
      }
    }
  }
}
</style>
